

/**
 * SNAP-SVG起動クラス
 * @param {Object} options 
 * @param {String} selector 
 * @param {String} path1 
 * @param {String} path2 
 * @param {Number} width 
 * @param {Number} height 
 * @param {String} style 
 * @param {Number} duration 
 * @param {boolean} autoplay 
 * @param {String} easing 
 */
class Svg {
  constructor(options) {
    try {
      if (!Snap) {
        throw new Error('Snap-svgが使用できません');
      }
      this.svg = Snap(options.selector).attr({
        width: options.width,
        height: options.height,
        viewBox: '0, 0, ' + options.width + ', ' + options.height,
        style: options.style ? options.style : ''
      });
      this.pathElm = this.svg.path(options.path1);
      this.path1 = options.path1;
      this.path2 = options.path2;
      this.duration = options.duration ? options.duration : 8000;
      this.easing = options.easing ? options.easing : mina.easeinout;

      if (options.autoplay) {
        this.autoplay();
      }
    } catch (e) {
      console.error(e);
    }


  }
  anim(shape, easing) {
    const self = this;
    self.pathElm.animate({
      path: shape
    }, self.duration, easing ? easing : self.easing);
  }
  morphing(isFirst) {
    const self = this;
    self.anim(self.path2, isFirst ? mina.linear : null);
    setTimeout(function () {
      self.anim(self.path1, null);
    }, self.duration);
  }
  autoplay() {
    const self = this;
    self.morphing(true);
    setInterval(function () {
      self.morphing();
    }, self.duration * 2);
  }
}
document.addEventListener('DOMContentLoaded', function (event) {

  // --- TOP-KVモーフィング ------
  if (document.getElementById('top-kv-background')) {

    const DURATION_BASE = 10000;
    const DURATION_VAR = 4000;

    const options = [
      {
        selector: '#elm01',
        path1: 'M110.56,265.52C51.3,272.77.9,221.85,10.09,162.86c1.87-12.01,6.17-23.61,14.17-33.52,35.3-43.74,55.36-37.36,94.71-86.91s122.17-31.2,135.94,78.83c9.72,77.62-69.42,135.09-144.36,144.26',
        path2: 'M136.08,266.68c-56.87,18.18-115.87-22.45-117.85-82.12-.4-12.15,1.66-24.35,7.67-35.58C52.43,99.42-22.45,87.38,6.97,31.36,36.39-24.66,216.95-7.51,251,98.02c24.02,74.45,21.85,127.83-50.07,150.82',
        width: 264.73,
        height: 271.05,
        style: 'fill:url(#grad-elm01); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm02',
        path1: 'M28.35,76.51c-3.95,12.31-8.36,24.47-13.35,36.4-11.86,28.36-26.71,80.24-.14,121.56,38.62,60.07,47.22,158.38,199.29,117.48,152.08-40.9,108.59-176.29,43.24-268.25S130.44-14.16,78.52,17.03c-32.45,19.5-45.19,43.91-50.18,59.48',
        path2: 'M28.35,76.51c-3.95,12.31-8.36,24.47-13.35,36.4-11.86,28.36,4.23,85.84,19.08,139.5,38.62,60.07,73.86,119.32,180.07,99.53,68.84-12.82,57.43-134.76-15.3-194.99C118.26,90.23,158.65,3,78.52,17.03c-32.45,19.5-45.19,43.91-50.18,59.48',
        width: 317.3,
        height: 361.62,
        style: 'fill:url(#grad-elm02); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm03',
        path1: 'M230.13,147.63s-12.41,44.94-56.44,49.85c-42.71,4.77-105.86-14.02-142.96-42.47-37.1-28.45-5.53-69.72-5.42-71.33,3.84-59.25,89-108,154.53-50.65,65.53,57.35,55.77,86.52,50.29,114.6',
        path2: 'M251.02,96.23s10.6,52.86-32.29,80.86c-41.61,27.17-116.58,40.67-169.7,30.62C-4.1,197.67,7,138.62,6.27,136.91-20.63,73.75,41.88-20.94,139.41,4.13c97.52,25.07,102.64,60.27,111.61,92.1',
        width: 252.18,
        height: 211.04,
        style: 'fill:url(#grad-elm03); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm04',
        path1: 'M318.66,101.75S220.85,58.17,173.59,26.25C126.33-5.68,71.07-3.01,38.33,53.87c-32.74,56.88-63.43,171.67-6.96,236.53,56.47,64.86,134.84,113.77,243.9,84.3,109.06-29.46,148.35-145.07,122.57-197.25-25.78-52.18-79.19-75.71-79.19-75.71',
        path2: 'M385.16,190s-29-83.07-35.86-131.5c-6.86-48.43-41.21-74.54-98-47.8-56.79,26.74-150.51,98.71-159.92,176.98-9.41,78.26,4.62,155.49,88.37,188.55,83.75,33.05,183.09-35.17,202.25-88.12,19.16-52.95,3.15-98.11,3.15-98.11',
        width: 405.47,
        height: 384.91,
        style: 'fill:url(#grad-elm04); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm05',
        path1: 'M29.2,207.2S-5.02,187.1.63,149.81c5.66-37.29,25.69-35.32,40.94-57.72,19.75-29.01,41.94-53.92,85.32-39.24,47.88,16.21,69.22,96.97,7.62,138.23s-83.44,26.81-105.32,16.12',
        path2: 'M103.76,229.95s-49.76,5.45-70.71-35.91c-20.96-41.36,1.14-54.3.78-87.97-.47-43.6,4.54-84.93,59.85-102.58,61.05-19.49,141.09,45.09,107.18,132.03-33.92,86.94-66.83,88.8-97.09,94.43',
        width: 208.93,
        height: 230.19,
        style: 'fill:url(#grad-elm05); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm06',
        path1: 'M141.25,13.65c-10.24,4.39-20.64,8.4-31.22,11.9-25.15,8.32-67.28,27.99-79.13,68.62-17.23,59.07-76.3,120.23,36.26,196.01,112.57,75.77,176.02-29.04,198.88-123.52,22.86-94.48-8.12-137.87-57.75-153.99-31.02-10.08-54.1-4.56-67.04.99',
        path2: 'M152.95,17.92c-6.62,5.63-13.45,11.02-20.54,16.12-16.84,12.13-43.7,36.36-43.04,67.18.96,44.81-28.84,101.75,73.01,124.77,101.84,23.02,124.7-64.9,119.64-135.37C276.96,20.16,243.66-1.58,202.8.09c-25.54,1.04-41.48,10.72-49.85,17.83',
        width: 282.67,
        height: 316.16,
        style: 'fill:url(#grad-elm06); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm07',
        path1: 'M1.62,97.62S-19.27,9.46,88.93,7.13c108.2-2.34,138.48,98.69,91.03,152.91C132.52,214.26-14.33,224,1.62,97.62',
        path2: 'M105.77,8.01s72.52,2.7,51.23,86.73c-21.3,84.03-105.76,85.84-137.49,37.64C-12.23,84.17,11.61-31.28,105.77,8.01',
        width: 201.68,
        height: 198.03,
        style: 'fill:url(#grad-elm07); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm08',
        path1: 'M11.37,190.57s-28.05-47.5,3.96-89.02,55.03-25.61,88.67-42.57c43.56-21.96,87.33-37.28,130.16,9.81,47.28,51.97,18.78,164.53-83.91,173.16-102.68,8.63-119.49-23.65-138.88-51.38',
        path2: 'M22.47,105.78S14.14,43.27,66.36,13.85c52.22-29.41,69.35-2.4,112.33-5.24,55.65-3.67,108.55-.27,132.62,68.4,26.57,75.8-53.66,181.55-165.59,144.82C33.79,185.11,30.51,143.63,22.47,105.78',
        width: 316.43,
        height: 243.38,
        style: 'fill:url(#grad-elm08); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm09',
        path1: 'M23.39,100.81c-39.52,30.07-26.92,86.91,22.46,101.4,15.63,4.58,34.86,8.56,58.52,11.39,123.39,14.74,193.38-111.38,195.22-149.05S209.35,3.95,98.85,56.36c-33.57,15.92-57.88,31.07-75.46,44.45',
        path2: 'M53.52,112.03c-21.96,40.44-3.11,107.99,33.63,120.51,11.62,3.96,25.63,6.82,42.5,7.83,87.95,5.28,113.82-154.58,108.38-200.39-5.45-45.81-73.21-64.19-140.26,10.53-20.37,22.7-34.47,43.52-44.24,61.52',
        width: 299.62,
        height: 240.5,
        style: 'fill:url(#grad-elm09); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm10',
        path1: 'M151.96,178.69c-60.04,51.37-40.91,148.48,34.13,173.23,23.74,7.83,52.96,14.63,88.92,19.46,187.48,25.18,222.42-108.12,225.22-172.48S434.5,13.21,266.61,102.75c-51,27.2-87.94,53.08-114.65,75.93',
        path2: 'M102.34,294.63c4.19,73.67,88.96,129.4,151.22,99.4,19.7-9.49,41.79-23.15,66.28-42.43,127.73-100.52,46.83-215.56-.38-262.24C272.25,42.68,140.48,1.16,111.15,169.41c-8.91,51.11-10.67,92.44-8.81,125.22',
        width: 500.31,
        height: 453.67,
        style: 'fill:url(#grad-elm10); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm11',
        path1: 'M45.89,267.1S-8.33,235.72,1.1,176.7c9.43-59.02,11.21-88.4,35.74-124C68.6,6.6,134.29-.76,203.14,21.95c76,25.07,109.01,152.5,10.52,218.44-98.49,65.94-133.07,43.35-167.77,26.71',
        path2: 'M179.18,294.12s-98.86,0-136.47-52.11C7.74,193.54,4.61,164.83,6.14,121.63,8.11,65.68,59.52,20.77,129.79,2.88c77.55-19.75,192.61,64.83,145.05,173.4-47.56,108.57-57.45,113.21-95.65,117.84',
        width: 285.99,
        height: 294.12,
        style: 'fill:url(#grad-elm11); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      },
      {
        selector: '#elm12',
        path1: 'M99.88,1.56S51.35-11.56,23.8,38.28C-3.74,88.12-6.36,98.62,10.69,135.34s103.61,65.58,128.53-22.3S99.87,1.56,99.87,1.56',
        path2: 'M125.48,20.47S89.36-14.49,41.14,15.8c-48.22,30.29,3.48,52.42.64,92.81-2.85,40.39-.12,93.31,64.2,28.46,64.33-64.85,19.5-116.6,19.5-116.6',
        width: 144.96,
        height: 170.95,
        style: 'fill:url(#grad-elm12); isolation:isolate; opacity:.7;',
        duration: createDuration(DURATION_BASE, DURATION_VAR),
        autoplay: true
      }
    ]

    for (let option of options) {
      new Svg(option);
    }

  }

  /**
   * アニメーションの変化時間を作成
   * @param {Number} time 
   * @param {Number} delta 
   * @returns 
   */
  function createDuration(time, delta) {
    const direction = Math.floor(Math.random() * 2000) % 2 === 0 ? 1 : -1;
    const duration = time + Math.floor(delta * Math.random()) * direction;
    // console.log(duration);
    return duration;
  }

  // --- KVのコピーのエフェクト ------
  if (document.querySelector('.--initLoad')) {
    document.querySelectorAll('.--initLoad').forEach(elm => {
      elm.classList.remove('--initLoad');
    })
  }

  // --- GSAP ------
  if (document.getElementById('top-concept')) {
    gsap.registerPlugin(ScrollTrigger);
    CustomEase.create("join01", "1,.07,.6,.59");
    CustomEase.create("join02", ".55,.35,.36,1.03");
    CustomEase.create("join03", ".81,0,.38,.91");
    CustomEase.create("join04", ".46,0,.37,.83");
    CustomEase.create("join05", ".86,.01,.19,1.06");

    function getRandomNumber() {
      return Math.floor(Math.random() * 5) + 1;
    }
    const EASING_LIST = ['join01', 'join02', 'join03', 'join04', 'join05'];
    // let ww = window.innerWidth;
    let wh = window.innerHeight;
    const section = document.querySelector('#top-concept .js-frontConcept');
    const wrapper = document.querySelector('#top-concept .js-frontConcept__Wrapper');
    const slider = document.querySelector('#top-concept .js-frontConceptSlider');
    const topPadding = Math.floor(wrapper.getBoundingClientRect().top - section.getBoundingClientRect().top);
    const startPoint = -1 * Math.floor(wh * 0.1);
    // const endPointJoin = ww > 768 ? Math.floor(section.clientHeight - wh * 0.6) : Math.floor(section.clientHeight - wh * 0.5);
    const endPointJoin = Math.floor(section.clientHeight - wh * 0.6);
    const hidePoint = Math.floor(section.clientHeight + slider.clientHeight / 2 - wh * 0.5);

    document.querySelectorAll('.js-frontConcept__effect').forEach(elm => {

      gsap.to(elm,
        {
          left: '50%',
          ease: EASING_LIST[getRandomNumber()],
          // ease: 'join01',
          scrollTrigger: {
            toggleActions: 'play pause resume reset',
            trigger: '#top-concept',
            start: `top top-=${startPoint}px`,
            end: `top top-=${endPointJoin}px`,
            scrub: true,
            // delay: 1,
            // markers: true
          },
        }
      );
      gsap.to(elm,
        {
          top: `${Math.floor(section.clientHeight - topPadding + slider.clientHeight / 2)}px`,
          // top: `${section.clientHeight - topPadding - wh * 0.1}px`,
          ease: EASING_LIST[getRandomNumber()],
          // ease: 'join03',
          scale: 0.2,
          opacity: 0,
          scrollTrigger: {
            toggleActions: 'play pause resume reset',
            trigger: '#top-concept',
            start: `top top-=${startPoint}px`,
            // end: `top top-=${endPointJoin}px`,
            end: `top top-=${hidePoint}px`,
            scrub: true,
            // delay: 1,
            // markers: true
          },
        }
      );

    });


  }

  // --- TOP - About us / About - Vision ------
  if (document.querySelector('.js-effectRound__Wrapper')) {
    const prp = Math.floor(document.querySelector('.js-effectRound__Wrapper').clientHeight * 0.163);
    ScrollTrigger.create({
      trigger: '.js-effectRound__Wrapper',
      start: `center-=${prp} bottom`,
      onEnter: () => {
        document.querySelector('.js-effectRound__Wrapper').classList.add('--showEffect');
      },
      once: true,
      // onLeaveBack: () => {
      //   document.querySelector('.js-effectRound__Wrapper').classList.remove('--showEffect');
      // }
    });
  }

  // --- TOPスライダー ------
  if (document.querySelector('.js-frontConceptSlider__slider')) {
    const swiper = new Swiper(".js-frontConceptSlider__slider", {
      speed: 10000, // スライド変化時間
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 2.5,
      spaceBetween: '6%',
      // centeredSlides: true,
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, //　スライダー表示時間
        disableOnInteraction: false,
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        561: {
          slidesPerView: 3,
          spaceBetween: '4%',
        },
        769: {
          slidesPerView: 3.5,
          spaceBetween: '3%',
        },
      }
    });
  }

  if (document.querySelector('.js-caseSlider')) {
    const swiper = new Swiper(".js-caseSlider", {
      speed: 10000, // スライド変化時間
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 2.2,
      spaceBetween: '3%',
      // centeredSlides: true,
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, //　スライダー表示時間
        disableOnInteraction: false,
      },
      breakpoints: {
        560: {
          slidesPerView: 4,
          spaceBetween: '1.5%',
        },
        769: {
          slidesPerView: 6,
          spaceBetween: '1.3%',
        },
      }
    });
  }

  if (document.querySelector('.js-frontCase__slider')) {
    const swiper = new Swiper('.js-frontCase__slider', {
      speed: 500, // スライド変化時間
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 1.2,
      spaceBetween: '4%',
      centeredSlides: true,
      // allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 3000, //　スライダー表示時間
        disableOnInteraction: false,
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        569: {
          slidesPerView: 1.8,
          spaceBetween: '3%',
        },
        769: {
          slidesPerView: 2.2,
          spaceBetween: '2%',
        },
      },
      pagination: {   // ページネーションの設定
        el: '.swiper-pagination',   // ページネーションラッパーのクラス
        type: 'bullets',   // ドットナビゲーション
        clickable: true,   // クリックしてスライド変更（初期値：false）
      },
      navigation: {	// 前後ナビゲーション
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  if (document.querySelector('.js-frontMember__slider')) {
    const swiper = new Swiper('.js-frontMember__slider', {
      speed: 10000, // スライド変化時間
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 1.5,
      spaceBetween: '4.2%',
      // centeredSlides: true,
      // allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, //　スライダー表示時間
        disableOnInteraction: false,
      },
      breakpoints: {
        501: {
          slidesPerView: 2,
          spaceBetween: '3.5%',
        },
        561: {
          slidesPerView: 2.2,
          spaceBetween: '3.5%',
        },
        769: {
          slidesPerView: 4,
          spaceBetween: '3.2%',
        },
      }
    });
  }

  if (document.querySelector('.js-articleSlider')) {
    const swiper = new Swiper('.js-articleSlider', {
      speed: 500, // スライド変化時間
      // loop: true,
      // loopAdditionalSlides: 1,
      slidesPerView: 1.2,
      spaceBetween: '5.4%',
      // centeredSlides: true,
      // allowTouchMove: false, // スワイプ無効
      // autoplay: {
      //   delay: 0, //　スライダー表示時間
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: ".js-articleSlider .swiper-pagination",
        type: 'bullets',   // ドットナビゲーション
        clickable: true,   // クリックしてスライド変更（初期値：false）
      },
      breakpoints: {
        416: {
          slidesPerView: 1.5,
          spaceBetween: '5.4%',
        },
        561: {
          slidesPerView: 2.2,
          spaceBetween: '4%',
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      }
    });
  }


  // --- OUR PROGRESS エフェクト ------
  if (document.querySelector('.js-progress-history')) {
    const ww = window.innerWidth;
    let position;
    if (ww > 768) {
      position = Math.floor(window.innerHeight / 3);
    } else if (ww > 559) {
      position = 230;
    } else {
      position = 180;
    }

    // ScrollTrigger.create({
    //   trigger: '#container',
    //   start: `top+=1 top`,
    //   onEnter: () => {
    //     document.querySelector('.js-progress-history-target').classList.remove('is-lock');
    //   },
    //   // once: true,
    //   onLeaveBack: () => {
    //     document.querySelector('.js-progress-history-target').classList.add('is-lock');
    //   }
    // });
    ScrollTrigger.create({
      trigger: '.js-progress-history-trigger-1st',
      start: `center bottom-=${position}`,
      onEnter: () => {
        document.querySelector('.js-progress-history-target').classList.add('is-1st');
      },
      // once: true,
      onLeaveBack: () => {
        document.querySelector('.js-progress-history-target').classList.remove('is-1st');
      }
    });
    ScrollTrigger.create({
      trigger: '.js-progress-history-trigger-2nd',
      start: `center bottom-=${position}`,
      onEnter: () => {
        document.querySelector('.js-progress-history-target').classList.add('is-2nd');
      },
      // once: true,
      onLeaveBack: () => {
        document.querySelector('.js-progress-history-target').classList.remove('is-2nd');
      }
    });
    ScrollTrigger.create({
      trigger: '.js-progress-history-trigger-3rd',
      start: `center bottom-=${position}`,
      onEnter: () => {
        document.querySelector('.js-progress-history-target').classList.add('is-3rd');
      },
      // once: true,
      onLeaveBack: () => {
        document.querySelector('.js-progress-history-target').classList.remove('is-3rd');
      }
    });
  }


});












// swiper 1つ表示
// const swiper = new Swiper(".js-swiper .swiper", {
//   speed: 1000,
//   loop: true,
//   autoplay: {
//     delay: 3000,
//   },
//   slidesPerView: 1,
//   spaceBetween: 0
// });


// // swiper01 PC3つ並び / TB2つ並び / SP1つ
// const swiper01 = new Swiper(".js-swiper01 .swiper", {
//   speed: 1000,
//   loop: true,
//   autoplay: {
//     delay: 2000,
//     disableOnInteraction: false,
//   },
//   slidesPerView: 1,
//   spaceBetween: 0,

//   // ブレークポイント（画面幅による設定）
//   breakpoints: {
//     // 画面幅が 768px 以上の場合（window width >= 768px）
//     768: {
//       slidesPerView: 2,
//       spaceBetween: 20
//     },
//     // 画面幅が 1024px 以上の場合（window width >= 1024px）
//     1024: {
//       slidesPerView: 3,
//       spaceBetween: 40
//     }
//   },
//   pagination: {
//     el: ".js-swiper01 .swiper-pagination",
//   },
//   navigation: {
//     nextEl: ".js-swiper01 .swiper-button-next",
//     prevEl: ".js-swiper01 .swiper-button-prev",
//   },
// });


// // swiper02 自動再生
// const swiper02 = new Swiper(".js-swiper02 .swiper", {
//   loop: true,
//   speed: 5000,
//   autoplay: {
//     delay: 0,
//     disableOnInteraction: false,
//   },
//   slidesPerView: 1.5,
//   spaceBetween: 10,

//   // ブレークポイント（画面幅による設定）
//   breakpoints: {
//     // 画面幅が 768px 以上の場合（window width >= 768px）
//     768: {
//       slidesPerView: 2.5,
//       spaceBetween: 20
//     },
//     // 画面幅が 1024px 以上の場合（window width >= 1024px）
//     1024: {
//       slidesPerView: 3.5,
//       spaceBetween: 30
//     }
//   },
// });


// // swiper03 サムネイルと連動するスライダー

// // サムネイル
// const swiper03_thumb = new Swiper('.js-swiper03__thumb', {
//   slidesPerView: 4,
//   spaceBetween: 30,
//   freeMode: true,
//   slideToClickedSlide: true,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
// })

// // メインスライダー
// const swiper03_main = new Swiper('.js-swiper03__main', {
//   speed: 1000,
//   autoplay: {
//     delay: 3000,
//     disableOnInteraction: false,
//   },
//   slidesPerView: 1,
//   loop: true,
//   loopedSlides: 6,
//   centeredSlides: true,
//   disableOnInteraction: true,
//   navigation: {
//     nextEl: '.js-swiper03 .swiper-button-next',
//     prevEl: '.js-swiper03 .swiper-button-prev',
//   },
//   thumbs: {
//     swiper: swiper03_thumb,
//   },
// })
